import { useSnapshot } from "valtio"
import { appStore } from "src/store/appStore"
import { canSeeWorkflowItem, type WorkflowItemDef } from "./workflowItems"

/**
 * Whether the signed-in user may see a given workflow item.
 *
 * One hook rather than a check at each render site: the rail, the overview and the route
 * all have to reach the same answer, and three copies of a permission test is how one of
 * them ends up out of step and quietly exposes a page.
 *
 * `hasAccess` already returns true for a super user, so an item restricted to a feature
 * granted only to Operator resolves to "Ops and super-admin" without naming either role.
 */
export function useWorkflowAccess(): (item: WorkflowItemDef) => boolean {
  const snap = useSnapshot(appStore)
  const permissions = snap.loggedInUser?.permissions
  return (item) =>
    canSeeWorkflowItem(item, (feature) => permissions?.hasAccess?.(feature) ?? false)
}
